import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import gql from "graphql-tag"
import ScheduledGroupCelebrationFragment from "../fragments/ScheduledGroupCelebration"
const mutation = gql`
  mutation UpdateGroupCelebration($groupCelebrationID: ID!, $walletTransferId: ID, $collaboratorIds: [ID]) {
    updateGroupCelebration(
      groupCelebrationID: $groupCelebrationID
      walletTransferId: $walletTransferId
      collaboratorIds: $collaboratorIds
    ) {
      ...ScheduledGroupCelebration
    }
  }
  ${ScheduledGroupCelebrationFragment}
`
export const updateGroupCelebrationMutationKey = getQueryNames(mutation)[0]
export default mutation
